import React from "react";
import SEO from "../components/SEO";
import Header from "../partials/header/Header";
import Breadcrumb from "../container/Breadcrumb/Breadcrumb";
// import HomeAbout from '../components/About/HomeAbout.jsx';

// import AboutFive from '../container/About/AboutFive';
// import TestimonialContainer from '../container/Testimonial/TestimonialContainer';
import Footer from "../container/Footer/Footer";
import ScrollToTop from "../components/ScrollToTop.jsx";
import EmptyTwo from "../container/Empty/EmptyTwo";
// import {Link} from "react-router-dom";

// import EmptyOne from '../container/Empty/EmptyOne';

const Deadlines = () => {
  const show = true;
  if (show) {
  return (
    <React.Fragment>
      <SEO title="Important Dates | DMBD 2026" />
      <Header />
      <Breadcrumb
        image="images/bg/banner2-opt.jpg"
        title="Important Dates"
        content="For Authors"
        contentTwo="Deadlines"
        linkage="/"
      />

      {/* <HomeAbout /> */}
      <EmptyTwo>
        <div className="entry-content">
          <p>
            <h4>Deadlines for DMBD&apos;2026:</h4>
          </p>
          <br />
          <table className="deadline">
            <tbody>
              <tr>
                <th width="200">Event</th>
                <th width="400">Deadline</th>
              </tr>
              <tr>
                <td>
                  {/* <del> */}
                  <b>
                    Special session
                  </b>
                  {/* </del> */}
                </td>
                <td>
                  {/* <del> */}
                  September 6th, 2026
                  {/* </del> */}
                   <br></br>
                  {/* <del> */}
                  {/* September 15th, 2026 */}
                  {/* </del> */}
                </td>
              </tr>
              <tr>
                <td>
                  {/* <del> */}
                  <b>
                    Tutorial proposal
                  </b>
                  {/* </del> */}
                </td>
                <td>
                  {/* <del> */}
                  September 20th, 2026
                  {/* </del> */}
                   <br></br>
                  {/* <del> */}
                  {/* September 15th, 2026 */}
                  {/* </del> */}
                </td>
              </tr>
              <tr>
                <td>
                  <del>
                  <b>
                    Paper submission
                  </b>
                  </del>
                </td>
                <td>
                  <del>
                  September 20th, 2026
                  </del>
                </td>
              </tr>
              <tr>
                <td>
                  <del>
                  <b>
                    Paper submission
                  </b>
                  </del>
                </td>
                <td>
                  <del>
                  October 10th, 2026
                  </del>
                </td>
              </tr>
              <tr>
                <td>
                  {/* <del> */}
                  <b>
                    Paper submission (fixed deadline)
                  </b>
                  {/* </del> */}
                </td>
                <td>
                  October 30th, 2026
                </td>
              </tr>
              <tr>
                <td>
                  {/* <del> */}
                    Notification of acceptance
                  {/* </del> */}
                </td>
                <td>
                  {/* <del> */}
                      November 15th, 2026
                  {/* </del> */}
                </td>
              </tr>
              <tr>
                <td>
                  {/* <del> */}
                    Camera-ready
                  {/* </del> */}
                </td>
                <td>
                  {/* <del> */}
                  November 30th, 2026
                  {/* </del> */}
                </td>
              </tr>
              <tr>
                <td>
                  {/* <del> */}
                    Author registration
                  {/* </del> */}
                </td>
                <td>
                  {/* <del> */}
                  November 30th, 2026
                  {/* </del> */}
                </td>
              </tr>
              {/* 
              <tr>
                <td>
                  <del>
                    <del>
                      ICSI-OC&apos;2022
                    </del>
                  </del>
                </td>
                <td>
                  <del>
                    <del>
                      May 27, 2022
                    </del>
                  </del>
                </td>
              </tr> */}
              <tr>
                <td>
                  {/* <del> */}
                    Conference dates
                  {/* </del> */}
                </td>
                <td>
                  {/* <del> */}
                    December 9th-12th, 2026
                  {/* </del> */}
                </td>
              </tr>
            </tbody>
          </table>
          {/* <div className="row">
            <h5>Click the link below to submit your paper to ICSI 2022</h5>
            <a
              className="btn btn-primary"
              href="https://easychair.org/conferences/?conf=icsi2022"
            >
              ICSI Online Paper Submission
            </a>
          </div> */}
        </div>
      </EmptyTwo>
      {/* <AboutFive />
            <TestimonialContainer classOption="bg-primary-blue" />
        <CallToActionTwo /> */}
      <Footer />
      <ScrollToTop />
    </React.Fragment >
  );
}
else {
  return (
    <React.Fragment>
      <SEO title="Important Dates | DMBD 2026" />
      <Header />
      <Breadcrumb
        image="images/bg/banner2.jpg"
        title="Important Dates"
        content="For Authors"
        contentTwo="Deadlines"
        linkage="/"
      />

      {/* <HomeAbout /> */}
      <EmptyTwo>
        <div>
          <h4>To be released.</h4>
        </div>
      </EmptyTwo>
      {/* <AboutFive />
            <TestimonialContainer classOption="bg-primary-blue" />
            <CallToActionTwo /> */}
      <Footer />
      <ScrollToTop />
    </React.Fragment>
  )
}
};

export default Deadlines;
